import { PublicHeader } from "@/components/PublicHeader";
import { PublicFooter } from "@/components/PublicFooter";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, Lock, Server, Clock, FileCheck } from "lucide-react";

const Security = () => {
  const securityFeatures = [
    {
      icon: Shield,
      title: "Conformité RGPD",
      description: "Fruitycall respecte intégralement le Règlement Général sur la Protection des Données. Vos données et celles de vos patients sont traitées dans le strict respect de la législation européenne."
    },
    {
      icon: FileCheck,
      title: "Données de santé",
      description: "Les messages contenant des données de santé sont traités avec le plus haut niveau de sécurité. Nous appliquons les normes HDS (Hébergeur de Données de Santé) pour garantir leur protection."
    },
    {
      icon: Server,
      title: "Hébergement sécurisé",
      description: "Toutes vos données sont hébergées sur des serveurs sécurisés chez OVH en France, garantissant une souveraineté numérique et une protection optimale."
    },
    {
      icon: Clock,
      title: "Conservation limitée",
      description: "Les messages vocaux et leurs transcriptions sont conservés pour une durée limitée conformément aux recommandations légales. Vous pouvez archiver ou supprimer vos messages à tout moment."
    },
    {
      icon: Lock,
      title: "Chiffrement des données",
      description: "Toutes les communications et données stockées sont chiffrées de bout en bout. Vos informations sont protégées par les technologies de cryptage les plus avancées."
    }
  ];
  
  return (
    <div className="flex min-h-screen flex-col">
      <PublicHeader />
      
      <main className="flex-1">
        {/* Hero */}
        <section className="section-spacing bg-gradient-to-br from-primary/5 via-background to-secondary/10">
          <div className="container-custom text-center">
            <div className="mx-auto mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
              <Shield className="h-8 w-8 text-primary" />
            </div>
            <h1 className="mb-4 text-4xl font-bold tracking-tight sm:text-5xl">
              Sécurité et confidentialité
            </h1>
            <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
              Votre tranquillité d'esprit et la protection des données de vos patients sont nos priorités absolues
            </p>
          </div>
        </section>
        
        {/* Security Features */}
        <section className="section-spacing">
          <div className="container-custom">
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {securityFeatures.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <Card key={index} className="card-interactive border-2">
                    <CardHeader>
                      <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
                        <Icon className="h-6 w-6 text-primary" />
                      </div>
                      <CardTitle className="text-xl">{feature.title}</CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="text-muted-foreground">{feature.description}</p>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </section>
        
        {/* Trust Section */}
        <section className="section-spacing bg-muted/30">
          <div className="container-custom">
            <Card className="border-2 border-primary/20">
              <CardContent className="p-12">
                <div className="mx-auto max-w-3xl text-center">
                  <h2 className="mb-6 text-3xl font-bold">
                    Une solution de confiance pour les professionnels de santé
                  </h2>
                  <div className="space-y-4 text-left text-muted-foreground">
                    <p>
                      Fruitycall a été conçu en collaboration avec des professionnels de santé pour répondre aux exigences strictes du secteur médical en matière de sécurité et de confidentialité.
                    </p>
                    <p>
                      Nous comprenons l'importance de la protection des données médicales et mettons tout en œuvre pour garantir un service sûr et conforme aux réglementations en vigueur.
                    </p>
                    <p>
                      Notre équipe de sécurité surveille en permanence nos systèmes et effectue des audits réguliers pour maintenir le plus haut niveau de protection.
                    </p>
                  </div>
                  
                  <div className="mt-8 grid gap-4 sm:grid-cols-3">
                    <div className="rounded-lg border bg-background p-4">
                      <div className="mb-2 text-3xl font-bold text-primary">100%</div>
                      <div className="text-sm text-muted-foreground">Conforme RGPD</div>
                    </div>
                    <div className="rounded-lg border bg-background p-4">
                      <div className="mb-2 text-3xl font-bold text-primary">24/7</div>
                      <div className="text-sm text-muted-foreground">Surveillance sécurité</div>
                    </div>
                    <div className="rounded-lg border bg-background p-4">
                      <div className="mb-2 text-3xl font-bold text-primary">France</div>
                      <div className="text-sm text-muted-foreground">Hébergement OVH</div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </section>
      </main>
      
      <PublicFooter />
    </div>
  );
};

export default Security;